import React from "react";
import "./index.less";
import img1 from "@/assets/img/img1.jpg";

const Page2: React.FC = () => {
  return (
    <section className="page2">
      <div className="info">
        <div className="text">
          ライブ感とシズル感に満ちた、作りたて・蒸し立て・焼き立て・揚げたての料理をぜひお楽しみください。
          銀座の中心に位置する当店で、特別なひとときをお過ごしいただけます。
        </div>
      </div>
      <div className="img">
        <img src={img1} alt="" />
      </div>
    </section>
  );
};

export default Page2;
